import { color } from "minimum-ui/tokens";
import { css } from "styled-components";

export const scrollbars = () => css`
  scrollbar-width: thin;
  // Using a nested template string as there was intellisense weirdness otherwise
  scrollbar-color: ${`${color.neutral[200]} ${color.neutral[100]}`};

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: ${color.neutral[200]};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    width: 6px;
    height: 6px;
    background: ${color.neutral[200]};
    border-radius: 3px;
  }
`;
